<template>
    <div class="posfinder-screen__location" :class="wrapperClass" @click.prevent="triggerFocus">
        <p class="h5 posfinder-screen__headline">
            <span>{{ location.title }}</span>
        </p>
        <p class="secondaryfont-regular posfinder-screen__text">
            {{ location.street }} {{ location.no }}<br/>
            {{ location.zip }} {{ location.city }}
        </p>
        <div class="posfinder-screen__location-meta">
            <span class="mainfont">{{ distanceFormat }} km</span>
            <a v-if="navigationLink" :href="navLink" class="posfinder-screen__gnav"></a>
        </div>
    </div>
</template>

<script>
    import {getNavLink} from "../../scripts/gMap";

    export default {
        name: "Location",
        props: {
            location: Object,
            navigationLink: Boolean,
            focus: Boolean
        },
        computed: {
            navLink() {
                return getNavLink(this.location.coords.lat, this.location.coords.lon)
            },
            distanceFormat(){
                const format = new Intl.NumberFormat('en-EN', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                });
                return format.format(this.location.distance);
            },
            wrapperClass() {
                const className = [];
                className.push("posfinder-screen__location--" + this.location.type);
                if (this.focus) {
                    className.push('posfinder-screen__location--focus');
                }
                return className.join(' ');
            }
        },
        methods: {
            triggerFocus() {
                this.$store.commit('clearResultFocus');
                this.$store.commit('setResultFocus', this.location);
                this.$emit('selectLocation', this.location);
            }
        }
    }
</script>
